import { VENDOR_LINKS } from 'utils/propertyLinks';

import OutboundLink from 'components/OutboundLink';

import './VendorsCard.css';

// Black-and-white logos by default; each has a colored `-hover` twin shown on hover
const links = [
	{
		label: 'Architects',
		imageFile: 'vendor-aapc',
		url: VENDOR_LINKS.AAPC,
	},
	{
		label: 'Code Consultants',
		imageFile: 'vendor-bvs',
		url: VENDOR_LINKS.BVS,
	},
	{
		label: 'Benchmarking',
		imageFile: 'vendor-benchmarking',
		url: VENDOR_LINKS.benchmarking,
	},
	{
		label: 'Contractors',
		imageFile: 'vendor-arkco',
		url: VENDOR_LINKS.ARKCO,
	},
	{
		label: 'Inspections',
		imageFile: 'vendor-azark',
		url: VENDOR_LINKS.AZARK,
	},
	{
		label: 'Documentation',
		imageFile: 'vendor-vps',
		url: VENDOR_LINKS.VPS,
	},
];

function VendorsCard() {
	return (
		<div className="vendors-card">
			<h2 className="vendors-card-title">Vendors</h2>
			<div className="vendor-links">
				{links.map((link) => (
					<OutboundLink
						className="vendor-link"
						noIcon
						url={link.url}
						key={link.url}
					>
						<span className="vendor-logo">
							<img src={`/${link.imageFile}.png`} alt={link.label} />
							<img
								className="vendor-logo-hover"
								src={`/${link.imageFile}-hover.png`}
								alt=""
								aria-hidden="true"
							/>
						</span>
						<span className="vendor-label">{link.label}</span>
					</OutboundLink>
				))}
			</div>
		</div>
	);
}

export default VendorsCard;
